import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBarFilter',
  standalone: false,
})
export class SearchBarFilterPipe implements PipeTransform {
  transform(items: any[], filter: any, defaultFilter: boolean): any[] {
    if (!items || !filter) {
      return items;
    }

    const filterKeys = Object.keys(filter);

    return items.filter((item) =>
      filterKeys.every((keyName) => {
        // Skip if filter value is undefined, null, or empty (except for specific cases)
        if (!filter[keyName] && filter[keyName] !== '') {
          return true;
        }

        // Handle null/undefined item values
        if (item[keyName] == null && !filter[keyName]) {
          return true;
        }

        // Handle numeric field 'nbrMembers'
        if (keyName === 'nbrMembers') {
          const filterValue = Number(filter[keyName]); // Convert filter value to number
          const itemValue = Number(item[keyName]);     // Convert item value to number
          return isNaN(filterValue) || filterValue === itemValue; // Exact match or skip if invalid
        }

        // Handle specific enum-like fields with exact matching
        if (keyName === 'familyType' || keyName === 'typePersonal' || keyName === 'typeInscrit') {
          const filterValue = filter[keyName].toString().toLowerCase();
          const itemValue = item[keyName] != null ? item[keyName].toString().toLowerCase() : '';
          return filterValue === '' || itemValue === filterValue;
        }

        // Default string-based filtering for other fields
        const itemValue = item[keyName] != null ? item[keyName].toString().toLowerCase() : '';
        const filterValue = filter[keyName].toString().toLowerCase();
        return itemValue.includes(filterValue);
      })
    );
  }
}